<template>
	<div class="model" :style="grapestyle">
		<div class="model_boder">

			<div class="model_top">
				<el-row>
					<el-col :span="8">
						<div class="top_datetime">
							<span class="top_datetime_time">{{time}}</span>
							<span class="top_datetime_date">{{date}}</span>
						</div>
					</el-col>
					<el-col :span="8">
						<h1 class="top-h1">金华特色农业种植监测和溯源技术平台</h1>
					</el-col>
					<el-col :span="8">
						<div class="top_unit">
							<p>研发单位：金华市农业农村大数据发展中心
								<br />
								合作单位：浙江创基电子有限公司
							</p>
						</div>
						<div class="top-iconbig">
							<img @click="toggleFullScreen" :src="togglesrc" alt="" />
						</div>
					</el-col>
				</el-row>
			</div>
			<div class="model_button">
				<div class="button_set" @click="iconbigdialog=true">
					设置农事提醒接收手机号
				</div>
				<el-dialog v-model="iconbigdialog" title="设置农事提醒接收手机号" width="500" align-center>
					<el-input placeholder="请输入电话号码" maxlength="11" v-model="ipnum" autocomplete="off" />
					<template #footer>
						<div class="dialog-footer">
							<el-button @click="iconbigdialog = false">取消</el-button>
							<el-button type="primary" @click="Updateipnum()">
								确认修改
							</el-button>
						</div>
					</template>
				</el-dialog>
			</div>
			<div style="width: 100%;height: 50px;">
				<Timeline @selectperiod="selectperioded" />
			</div>

			<dormancy v-if="selectperiods===1" />
			<spring v-if="selectperiods===2" />
			<three v-if="selectperiods===3" />
			<four v-if="selectperiods===4" />
			<five v-if="selectperiods===5" />
			<six v-if="selectperiods===6" />
			<seven v-if="selectperiods===7" />
			<eight v-if="selectperiods===8" />
			<nine v-if="selectperiods===9" />


			<div class="model_bottom">
				<div class="bottom_title">
					<div class="bottom_title_item" :class="{ bottom_item_active: buttonactiveIndex === 0 }"
						@click="addbuttonActive(0);router.replace('/')">
						种植监测
					</div>
					<div class="bottom_title_item" :class="{ bottom_item_active: buttonactiveIndex === 1 }"
						@click="addbuttonActive(1)">
						葡萄生长模型
					</div>
					<div class="bottom_title_item" :class="{ bottom_item_active: buttonactiveIndex === 2 }"
						@click="addbuttonActive(2)">
						农产品溯源
					</div>
				</div>
			</div>

		</div>
	</div>
</template>

<script setup>
	import {
		ref,
		onMounted,
		onUnmounted
	} from 'vue';
	import big from '@/assets/home/big.png'
	import min from '@/assets/home/min.png'
	import {
		useRouter
	} from "vue-router";
	import {GetUserTables,Updatephone} from '@/api/api.js'
    import { ElMessage } from 'element-plus'

	import {
		useStore
	} from 'vuex';

	const store = useStore();

	import mitt from '../../utils/bus.js'
	let ipnum = ref('')

	import Timeline from './timeline/index.vue';
	import dormancy from './dormancy/index.vue';
	import spring from './spring/index.vue';
	import three from './three/index.vue';
	import four from './four/index.vue';
	import five from './five/index.vue';
	import six from './six/index.vue';
	import seven from './seven/index.vue';
	import eight from './eight/index.vue';
	import nine from './nine/index.vue';
	const router = useRouter();
	let active = ref(8)
	let grapestyle = ref();
	
	
	 let togglesrc = ref(big)
	 
	if (store.state.isFullscreen) {
		togglesrc.value = min;
	} else {
		togglesrc.value = big;
	}

	let date = ref("");
	let time = ref("");
	let selectperiods = ref(1)

	let iconbigdialog = ref(false)

	const resize = () => {
		// 获取浏览器窗口的宽度
		const windowWidth = window.innerWidth;
		grapestyle.value = `transform:scale(${windowWidth/1920});`

	}

	// 在组件挂载后添加事件监听器
	onMounted(() => {
		// 初始化时调用一次 resize 函数，确保初始样式正确
		resize();
		// 监听窗口大小变化，当窗口大小变化时执行 resize 函数
		window.addEventListener('resize', resize);
		// document.addEventListener('keydown', handleKeyPress);
		GetUserTables(1).then(res=>{
			ipnum.value=res.data.phone;
		}).catch(err=>{
			console.error(err)
		})


	});
	onUnmounted(() => {
		window.removeEventListener('resize', resize);
		// document.removeEventListener('keydown', handleKeyPress);
		clearInterval(interval);
	})
	const interval = setInterval(() => {
		const days = ['日', '一', '二', '三', '四', '五', '六'];
		const dt = new Date();
		var y = dt.getFullYear();
		var mt = dt.getMonth() + 1;
		var day = dt.getDate();
		var h = dt.getHours(); //获取时
		var m = dt.getMinutes(); //获取分
		var s = dt.getSeconds(); //获取秒
		const dayIndex = dt.getDay();
		date.value = y + "年" + mt + "月" + day + "日" + " " + "星期" + days[dayIndex];
		time.value = h + ":" + m + ":" + s;
	}, 1000);

	function toggleFullScreen() {

		window.parent.postMessage({
			type: "changeFullScreen",
			data: !store.state.isFullscreen
		}, "*");
	}

	window.addEventListener('message', function(event) {
		if (event.data && event.data.type === "changeFullScreen") {
			togglesrc.value = event.data.data ? min : big;
			store.dispatch('toggleFullscreen', event.data.data);
		}
	});

	function Updateipnum() {
		
		Updatephone(ipnum.value).then(res=>{
			iconbigdialog.value = false;
		}).catch(err=>{
			ElMessage.error('修改失败')
			GetUserTables(1).then(res=>{
				ipnum.value=res.data.phone;
			}).catch(err=>{
				
				console.error(err)
			})
		});
		
		
	}

	let buttonactiveIndex = ref(1);

	function addbuttonActive(e) {
		buttonactiveIndex.value = e;
		if (e == 2) {
			window.parent.postMessage({
				type: "changeTab",
				data: "trace"
			}, "*");
		}

	}
	mitt.on('Changerouter', (data) => {
		buttonactiveIndex.value = data
	})

	// function handleKeyPress(event) {
	// 	// 如果按下的是F11键
	// 	if (event.key === 'F11') {
	// 		// 检查浏览器是否支持全屏API
	// 		if (document.fullscreenEnabled) {
	// 			// 如果当前不是全屏状态，则进入全屏，否则退出全屏
	// 			if (!document.fullscreenElement) {
	// 				// document.documentElement.requestFullscreen(); // 进入全屏
	// 				window.parent.postMessage({ type: "changeFullScreen", data: true }, "*");
	// 				togglesrc.value = min

	// 			} else {
	// 				// document.exitFullscreen(); // 退出全屏
	// 				window.parent.postMessage({ type: "changeFullScreen", data: false }, "*");
	// 				togglesrc.value = big
	// 			}
	// 		} else {
	// 			console.error('浏览器不支持全屏功能');
	// 		}
	// 	}
	// }

	function selectperioded(index) {
		selectperiods.value = index
	}
</script>

<style scoped lang="scss">
	.model {
		font-size: 13px;
		margin: 0px;
		padding: 0px;
		width: 1920px;
		height: 1080px;
		background-image: url("../../assets/home/backcolor.png");
		background-repeat: no-repeat;
		background-size: 100% 100%;
		transform-origin: top left;
	}

	.model_boder {
		width: 1920px;
		height: 1080px;
		background-image: url("../../assets/home/top.png");
		background-repeat: no-repeat;
		background-size: 100% 100%;
	}

	.model_top {
		height: 70px;
		width: 100%;
		position: relative;


		.top_datetime {
			line-height: 70px;
			color: #c9ffff;
			padding-top: 5px;

			.top_datetime_time {
				font-size: 16px;
				padding-left: 30px;
			}

			.top_datetime_date {
				font-size: 16px;
				padding-left: 10px;
			}
		}

		.top-h1 {
			text-align: center;
			line-height: 70px;
			color: #c9ffff;
		}

		.top_unit {
			color: #a1d1d0;
			position: absolute;
			top: 25px;
			right: 100px;

		}

		.top-iconbig {
			padding-left: 570px;
			line-height: 70px;
			padding-top: 10px;
		}
	}


	.button_set {
		width: 186px;
		height: 20px;
		line-height: 20px;
		font-size: 16px;
		color: white;
		padding: 5px;
		padding-left: 13px;
		margin-top: 20PX;
		margin-left: 1680PX;
		background-image: url('../../assets/model/button.png');
		background-size: 100% 100%;
	}


	.model_bottom {
		margin-top: 35px;

		.bottom_title {
			width: 25%;
			display: flex;
			font-size: 14px;
			margin: 0 auto;
			margin-top: 20px;
			justify-content: space-between;
			color: #00a580;

			.bottom_title_item {
				text-align: center;
				width: 142px;
				line-height: 30px;
				height: 20px;
				background-image: url('../../assets/home/mid-bot-defalt.png');
				padding: 5px;
				background-size: 100% 100%;
				margin-left: 20px;
			}

			.bottom_item_active {
				width: 185px;
				background-image: url('../../assets/home/mid-bot-hover.png');

				color: white;
			}
		}

	}
</style>